export const ui = {
    init: () => {
        ui.stickyHeader();
        ui.toggleSearch();
        ui.setBackToTop();
    },
    stickyHeader: () => {
        let $header = document.querySelector('.header--main');

        if ($header) {
            setStickyHeader();

            window.addEventListener('scroll', function (event) {
                setStickyHeader();
            });

        }

        function setStickyHeader() {

            let topOffset = window.scrollY;

            // Set custom top-offset CSS var
            let headerHeight = window.getComputedStyle($header).height;
            document.documentElement.style.setProperty('--header-offset', headerHeight);

            if (topOffset > 20) {
                $header.classList.add('sticky');
            } else {
                $header.classList.remove('sticky');
            }
        }
    },
    toggleSearch: () => {
        let $toggle = document.querySelector('.toggle-search');
        if ($toggle) {
            let $formSearch = document.querySelector('.form--search');
            let $formSearchWrap = $formSearch.querySelector('.form--search-wrap');
            let $formSearchInput = $formSearchWrap.querySelector('input[type="text"]');
            $toggle.addEventListener('click', () => {
                $formSearchWrap.classList.remove('hidden');
                // console.log($formSearchInput);
                setTimeout(() => {
                    $formSearchInput.focus();
                }, 200)
            });

            document.addEventListener('click', function (event) {
                var isClickInside = $formSearch.contains(event.target);

                if (!isClickInside) {
                    $formSearchWrap.classList.add('hidden');
                    //the click was outside the specifiedElement, do something
                }
            });
        }
    },

    setBackToTop() {
        const selector = '.btn--backtotop';

        if (!document.querySelector(selector))
            return;

        let $button = document.querySelector(selector);

        $button.addEventListener('click', () => {
            window.scrollTo({
                'top': 0,
                behavior: 'smooth'
            });
        });

        window.addEventListener('scroll', function (event) {
            let topOffset = window.scrollY;

            if (topOffset < 200) {
                $button.classList.add('hidden');
            } else {
                $button.classList.remove('hidden');
            }

        });

    }
}